import { request } from '@/request'
import { LOAD_ESCOLAS } from './types'

export const actions = {
  carregarEscolas (store) {
    return new Promise((resolve, reject) => {
      try {
        request.get('pesquisa/retorno-atividades-escolares/listar-escolas')
          .then(response => {
            store.commit(LOAD_ESCOLAS, response.data)
            resolve()
          })
          .catch(error => {
            reject(error)
          }); 
      } catch (e) {
        reject(e)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/pesquisa_aulas/actions.js